/* global PIE, ProtectPANandCVV, ValidatePANChecksum */

/**
 * Checks to see if the getKey.js script is mounted to the page correctly
 *
 * @returns the flag
 */
export function isPieKeyScriptDownloaded() {
  if ((typeof (PIE) === 'undefined') ||
    (typeof (PIE.K) === 'undefined') ||
    (typeof (PIE.L) === 'undefined') ||
    (typeof (PIE.E) === 'undefined') ||
    (typeof (PIE.key_id) === 'undefined') ||
    (typeof (PIE.phase) === 'undefined')) {
    return false
  }
  return true
}

/**
 * Checks to see if the encryption.js script is mounted to the page correctly
 *
 * @returns the flag
 */
export function isPieEncryptionScriptDownloaded() {
  if ((typeof ValidatePANChecksum !== 'function') ||
    (typeof ProtectPANandCVV !== 'function')) {
    return false
  }
  return true
}

/**
 * Encrypts the credit card number and security code
 *
 * @param {String} ccno the credit card number
 * @param {String} cvv the credit card security code
 * @param {Boolean} embed a flag on whether or not to use and embeded key
 * @returns returns an object with the encryption details
 */
export function doEncryption(ccno, cvv, embed) {
  if (embed) {
    // Check MOD 10 digit, since PIE embedded encryption
    // requires that the MOD 10 checksum is valid.
    if (!ValidatePANChecksum(ccno)) {
      return null
    }
  }

  const result = ProtectPANandCVV(ccno, cvv, !embed)

  return {
    keyId: PIE.key_id,
    phase: PIE.phase,
    cardNumber: result[0],
    securityCode: result[1],
    integrityCheckVal: result[2],
  }
}

export default { isPieKeyScriptDownloaded, isPieEncryptionScriptDownloaded, doEncryption }